import { CartFlyout, CartProduct } from '@westwing/ui-kit/ContentFlyout/CartFlyout';
import React from 'react';
import { CartProductItem } from '@westwing/ui-kit/ContentFlyout/CartFlyout/types';
import CartFlyoutContainer from '../CartFlyoutContainer';
import { ClubLink } from '../types/clubLinksTypes';
import { useClubContext } from '../hooks/ClubContext';
import { useHeaderContext } from 'Components/HeaderContext';

interface CartFlyoutWrapperProps {
    amountOfItems: number;
    remainingTime: number;
    products: CartProductItem[];
    remindAt: number;
    isVisible: boolean;
    totalPrice: string;
    isDeliveryUpdateVisible: boolean;
}

const CartFlyoutWrapper = ({
    amountOfItems,
    remainingTime,
    products = [],
    remindAt,
    isVisible,
    totalPrice,
    isDeliveryUpdateVisible,
}: CartFlyoutWrapperProps): JSX.Element => {
    const { t } = useHeaderContext();
    const { links } = useClubContext();
    const cartUrl = links[ClubLink.CART].path;
    return (
        <CartFlyoutContainer data-testid="oww-header-cart-flyout-container" $isVisible={isVisible}>
            <CartFlyout
                amountOfItems={amountOfItems}
                maxAmountOfItems={2}
                cartUrl={cartUrl}
                subtotal={totalPrice ?? ''}
                totalSumLabel={t('OwwHeader_Total sum')}
                dataTestId="oww-header-cart-flyout"
                bottomDataTestId="oww-header-cart-flyout-bottom"
                seeProductsLabel={t('OwwHeader_All products in your cart')}
                allProductsLinkComponent="a"
                allProductsLinkProps={{ href: cartUrl }}
                goToCartLabel={remainingTime > 0 ? t('OwwHeader_To Cart') : t('OwwHeader_Restore product')}
                goToCartProps={{ href: `${cartUrl}${remainingTime > 0 ? '' : '?restore_cart=1'}` }}
                productQuantityLabel={t('OwwHeader_Quantity')}
                isDeliveryUpdateVisible={isDeliveryUpdateVisible}
                deliveryUpdateText={`${t('OwwHeader_The delivery time of this product has changed.')} ${t(
                    'OwwHeader_You will see them in the shopping cart.'
                )}`}
                timer={{
                    remainingTime,
                    startsTimeoutAt: remindAt,
                    reservedForLabel: t('OwwHeader_Reserved for you for'),
                    minutesLabel: t('OwwHeader_minutes'),
                    expiredTimeReservedForLabel: t('OwwHeader_reservation'),
                    expiredTimeLabel: t('OwwHeader_expired'),
                    infoText: t(
                        'OwwHeader_The items in your cart are reserved for a limited time only. After that they will be made available for all customers again'
                    ),
                }}
            >
                {products.map(product => (
                    <CartProduct
                        key={`${product.name}`}
                        quantityLabel={t('OwwHeader_Quantity')}
                        quantity={product.quantity}
                        price={product.price}
                        brand={product.brand}
                        name={product.name}
                        dataTestId="oww-header-cart-flyout-product"
                        quantityDataTestId="oww-header-cart-flyout-product-quantity"
                        productLinkProps={{ href: product.productUrl }}
                        productImageComponent="img"
                        productImageProps={{
                            src: product.image,
                        }}
                        productLinkComponent="a"
                    />
                ))}
            </CartFlyout>
        </CartFlyoutContainer>
    );
};

export default CartFlyoutWrapper;
